import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-aboutme',
  templateUrl: './aboutme.component.html',
  styleUrls: ['./aboutme.component.css']
})
export class AboutmeComponent implements OnInit, OnDestroy {
  isVisible = false;
  observer!: IntersectionObserver;
  // La altura del carrusel la resuelve el CSS: en escritorio se estira hasta
  // el final de la tarjeta de perfil; en tablet/celular es una fila horizontal.

  // Las tarjetas miden 260px como máximo: 560px de lado largo cubre pantallas retina.
  logros = [
    { image: 'assets/images/fotografia1-w560.webp', alt: 'Natalia Güechá Nieto, psicóloga clínica, sonriendo en su consultorio' },
    { image: 'assets/images/fotografia2-w560.webp', alt: 'Natalia Güechá durante una sesión de terapia psicológica' },
    { image: 'assets/images/fotografia3-w560.webp', alt: 'Retrato de Natalia Güechá, magíster en psicología clínica' },
    { image: 'assets/images/fotografia4-w560.webp', alt: 'Natalia Güechá, psicóloga clínica en Bogotá, Colombia' },
    { image: 'assets/images/fotografia5-w560.webp', alt: 'Natalia Güechá atendiendo terapia online desde Bogotá' },
  ];

  logrosDuplicados: { image: string; alt: string }[] = [];

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.logrosDuplicados = [...this.logros, ...this.logros];
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isVisible = true;   // activa animación
        } else {
          this.isVisible = false;  // pausa animación
        }
      });
    }, { threshold: 0.2 });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
